import {
  SET_ACTIVE_NOTE_ID,
  TOGGLE_EXPAND_NOTE,
  EXPAND_NOTE,
  EXPAND_NOTES,
} from './actionTypes'

export const setActiveNoteId = activeNoteId => ({
  type: SET_ACTIVE_NOTE_ID,
  payload: { id: activeNoteId },
})

export const toggleExpandNote = ({ noteId }) => ({
  type: TOGGLE_EXPAND_NOTE,
  payload: { noteId },
})

export const expandNote = ({ noteId }) => ({
  type: EXPAND_NOTE,
  payload: { noteId },
})

export const expandNotes = ({ noteIds }) => ({
  type: EXPAND_NOTES,
  payload: { noteIds },
})
